export const messages = {
  en: {
    searchFeatures: {
      label: "Search features",
      play: "Play video",
      pause: "Pause",
      expand: "Expand video",
      close: "Close video",
      videoError: "The video could not be loaded. Please try again.",
      speed: {
        title: "Results in seconds",
        description: "The first results appear right away. Start browsing options without waiting for the full search to finish."
      },
      filters: {
        title: "Improved filters",
        description: "Filter by airline, time and airport to find the right option without extra steps."
      },
      controls: {
        title: "Quick selection",
        description: "Select airports using the arrow keys and change dates with one click to work faster."
      },
      query: {
        title: "Updated Copilot",
        description: "Copilot now recognizes text, GDS commands and booking details more accurately."
      },
      history: {
        title: "Search history at your fingertips",
        description: "Bring back previous queries with the ↑ and ↓ keys in Copilot and AI filters without retyping."
      }
    },
    title: "Partners",
    connectedPartners: "Connected",
    allPartners: "Available",
    issuesTitle: "Technical works",
    issuesDescription: "We are updating DRCT and making sure that everything works fine. Usually it takes 15 minutes.",
    partner: "Partner",
    chanells: "Channels",
    currency: "Currency",
    balance: "Balance",
    additional: "Additional information",
    noChannels: "No active channels",
    connect: "Connect",
    pending: "Pending...",
    tabs: {
      connectedTitle: "You haven't connected to a partner",
      connectedDescription: "Select a partner and connect to him. When the partner confirms your application, you will be able to book and issue tickets via him."
    },
    tickets: {
      locatorCopied: "Locator copied",
      locator: "Locator",
      search: "Find",
      searchPlaceholder: "Enter locator, ticket number or last name and press enter key",
      adminSearchPlaceholder: "Enter locator, ticket number, partner id, company id, IATA code or last name and press enter key",
      emptySearchTitle: "No ticket found",
      emptySearchDescription: "Check if locator, ticket number or last name is correct and try again.",
      title: "Sales",
      today: "Today",
      week: "Week",
      month: "Month",
      export: "Export to",
      date: "Date and time",
      pax: "Passenger",
      type: "Type",
      number: "Number",
      status: "Status",
      route: "Itinerary",
      agency: "Partner",
      company: "Company",
      sum: "Total",
      download: 'Download a ticket',
      downloadButton: "Download",
      downloadWithPrice: "With Price",
      downloadWithoutPrice: "No Price",
      downloadTitle: 'Download ticket',
      downloadDescription: 'Download ticket with fare taxes and fees or with total only',
      downloadWithBreakdown: 'With Fare & taxes',
      downloadWithoutBreakdown: 'Total Only',
      fare: 'Fare',
      tax: 'Taxes and fees',
      total: 'Total',
      add: "Add",
      update: "UPD",
      ok_button: "Apply",
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortMonths: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
      shortDays: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      emptyTitle: "There are no tickets for these dates",
      emptyDescription: "Try to select other dates.",
      passengerCopied: "Passenger copied",
      ticketNumberCopied: "Number copied",
      emailCopied: "E-mail copied",
    },
    transactions: {
      partner: "Partner",
      title: "Transactions",
      date: "Date and time",
      initiator: "Initiator",
      company: "Company",
      description: "Description",
      sum: "Total",
      emptyTitle: "There are no transactions yet",
      emptyDescription: "After first operations the following transactions will be displayed: write-offs and top-ups, purchase and cancellation of tickets.",
      search: "Find",
      searchPlaceholder: "Enter locator and press enter key",
    },
    header: {
      search: "Search",
      bookings: "Bookings",
      partners: "Partners",
      management: "Management",
      sales: "Sales",
      analytics: "Analytics",
      transactions: "Transactions",
      profile: "Profile",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      credentials: "Credentials"
    },
    profile: {
      disconnect: "Disconnect",
      profile: "Profile",
      account: "Account",
      partner: "Partner",
      support: "Supports",
      firstName: "First name",
      secondName: "Second name",
      company: "Company",
      logOut: "Logout",
      saveMain: "Save",
      phoneNumber: "Phone number",
      changePhone: "Change",
      mail: "E-mail",
      changeEmail: "Change",
      labelPhone: "Enter new phone number",
      hintPhone: "Enter your phone number, we will send you a confirmation SMS",
      backPhone: "Back",
      savePhone: "Next",
      labelOTP: "Enter code from SMS",
      resultOTP: "We have sent an SMS code to the number",
      resendOTP: "Send code again",
      changeNumberOTP: "Change number",
      saveOTP: "Next",
      labelNewEmail: "Enter new e-mail",
      backEmail: "Back",
      saveEmail: "Next",
      confirmEmail: "Confirm your e-mail",
      descEmail: "Click on the link we have sent to your e-mail",
      spamEmail: "If there is no letter, check the spam folder",
      alreadyTakenEmail: "E-mail is already taken",
      takenEmail: "This e-mail is already taken by another account. If you still want to change your e-mail, please try another one instead of",
      backToEmail: "Change the e-mail"
    },
    search: {
      flightCheckboxTooltip: 'Show results with this flight only',
      priceForOne: "Per 1 adult",
      choose: "Choose",
      directFlight: "Direct flight",
      charterFlight: "Charter",
      airlineOffer: "Offer from airline",
      airlineOfferTooltip: "You see the prices as on the airline's website without additional fees. Click \"Check price and book\" to buy a ticket on the airline's website.\n\nPowered by",
      charterTooltip: "You are lucky 😊\n\nFinding tickets for charter flights is rare. They are cheaper than regular flights and offer direct flights to unique destinations. We advise you to pay attention to the fare rules. Usually, exchanges and refunds are not allowed.",
      airlineOfferButton: "Check price and book",
      oneConnection: "1 connection",
      oneStop: "1 stop",
      connections: "connections",
      operated: "Operated by",
      priceWithoutBag: "Price without baggage",
      priceWithBag: "Price with baggage",
      withBag: "With baggage",
      adtHint: "Over 12 years old",
      chdHint: "From 2 to 12 years",
      infHint: "Up to 2 years, no seat",
      seaHint: "Merchant Seaman",
      adtTitle: "Adults",
      chdTitle: "Children",
      infTitle: "Infants",
      seaTitle: "Seamen",
      passenger: "passengers",
      passengers1_4: "passengers",
      passengers4_more: "passengers",
      promoTitle: "Add promo code",
      promoDescription: "Enter a promo code to apply it to the booking. The discount will be displayed after creating the reservation.",
      promoPlaceholder: "Enter a promo code",
      promoSubmit: "Add",
      promoCorrect: "Promo code added",
      baggage: "Baggage",
      under_seat: "Under seat",
      underSeatBagTooltipTitle: "Underseat Bag",
      underSeatBagTooltipDimensions: "40x30x15 cm",
      cabinBagTooltipTitle: "Cabin Bag",
      cabinBagTooltipDimensions: "55x40x23 cm",
      pegasusFlexibleChangeTitle: "Flexible Change Right",
      pegasusFlexibleRefundTitle: "Flexible Refund Right",
      pegasusFlexibleTimelineSevenDays: "(up to 7 days before the flight)",
      pegasusFlexibleTimelineTwoHours: "(up to 2 hours before the flight)",
      cabin_bag: "Cabin bag",
      seat: "Seat",
      seatFree: "Included",
      seatPaid: "Paid",
      seatPartiallyFree: "Partially included",
      seatNotIncluded: "Not included",
      seatStandardIncluded: "Standard",
      seatStandardAndPreferredIncluded: "Standard and preferred",
      priority_boarding: "Priority boarding",
      included: "Included",
      meal: "Meal",
      changes: "Changes",
      refund: "Refund",
      beforeDeparture: "Before departure",
      afterDeparture: "After departure",
      perPass: "Per 1",
      from: "From",
      to: "To",
      search: "Search",
      fromDate: "Departure",
      backDate: "Return",
      dayNamesShort: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      dayNames: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      allFlights: "All flights",
      noTransfer: "Direct",
      oneTransfer: "Up to 1 connection",
      cheapest: "Cheapest",
      fastest: "Fastest",
      fare_rules: "Fare Rules",
      fare_rules_in_future: "We are working on implementing the rules. We will add them in September 🤗",
      chooseTo: "Select fare for outbound flight",
      chooseBack: "Select fare for inbound flight",
      inputDataHint: "Enter the data in Latin as specified in the document",
      lastName: "Last name",
      firstName: "First name",
      dateOfBirth: "Date of birth",
      gender: "Gender",
      book: "Book",
      book_and_pay: "Instant issue",
      createTwoBookings: "Create 2 bookings",
      virtualInterlineAlert: "Two separate bookings will be created for this itinerary. Please check the details before continuing",
      virtualInterlineTooltip: "<p>1. This itinerary includes two bookings. Each one must be ticketed separately</p><p>2. Refunds, changes, exchanges, and additional services are handled separately under each booking's fare rules</p><p>3. Changes or cancellations in one booking do not entitle the passenger to a free change or refund in the other</p>",
      issue: "Continue",
      adt: "Adult",
      chd: "Child",
      total: "Total",
      inf: "Infant",
      searchTitle: "Search",
      searchTitleText: "Copilot",
      switchOnForm: "Form",
      switchOnTerminal: "Terminal",
      switchOnText: "Copilot",
      copilotSearch: "Search",
      copilotEdit: "Edit",
      copilotDropImage: "Drop the image anywhere to add it to your search",
      copilotAddClarification: "You can add filters, for example: evening flights with no baggage",
      copilotPastedImagePreview: "Pasted image preview",
      copilotRemoveImage: "Remove image",
      unknownError: "Unknown error",
      removeAiFilter: "Remove AI filter",
      exclude: "Exclude: {values}",
      directFlights: "Direct flights",
      upToOneConnection: "Up to 1 connection",
      removeDirectFlightsFilter: "Remove Direct flights filter",
      removeOneConnectionFilter: "Remove Up to 1 connection filter",
      resetAllFilters: "Reset all",
      resetFilter: "Reset",
      filterAirlines: "Airlines",
      filterAirports: "Airports",
      filterRouteAirports: "From — To",
      filterTransferAirports: "Transfers",
      filterTimes: "Times",
      filterTakeOff: "Take-off",
      filterLanding: "Landing",
      filterTakeOffFrom: "Take-off from {city}",
      filterLandingAt: "Landing at {city}",
      filterDuration: "Duration",
      filterTransfer: "Transfer",
      searchMC: "Search Multi-City",
      addRoute: "Add Route",
      removeRoute: 'Remove route',
      backToForm: 'Back to Form',
      terminalHint: "Use the usual commands to find the flight. For example: AN15OCTKBPBCN*17OCT/1ADT/1CHD",
      formHint: "Look for, book and issue tickets to any destination in the world.",
      textHint: "Search in your preferred format: text, command, or image.",
      flightTo: "Flight to",
      there: "Outbound",
      back: "Inbound",
      connection: "Connection",
      technical_stop: "Technical stop",
      duration: "duration",
      datepickerHeader: "Choose date",
      onewayButton: "Don’t need return",
      journeyTime: "On the way",
      copyHint: "Click to copy option",
      copyAirline: "Airline",
      copied: "The option copied",
      textPlaceholder: "Paste or type a search query",
      recognizeQuestion: "Did we recognize it correctly?",
      submitSearchResult: "Thank you for the feedback",
      noFlightsTitle: "Change the filters",
      noFlightsDescription: "We've found options, but they don't match the specified filters. Modify your search please.",
      aiFilters: "AI Filters",
      filterFlights: "FILTER",
      filterPlaceHolder1: "Morning departures on Lufthansa or Lot",
      filterPlaceHolder2: "Only business up to 6000 EUR",
      filterPlaceHolder3: "Not via Great Britain",
      filterPlaceHolder4: "Economy with a stopover in Madrid",
      filterPlaceHolder5: "Only evening arrival in Paris without baggage",
      smartSort: "Optimal",
      aiInfoTooltip: "Enter text in any format to filter the desired flights. Specify your preferences for flight number, price, or service class, then click \"Filter\". <br><br>Click the \"i\" to view the instructions.",
      alternativeClosedTextBold: "We have found alternative options",
      alternativeClosedText: "Check flight options from nearby airports",
      alternativeOpenText: "You are viewing flight options from nearby airports",
      alternativeFrom: "from",
      alternativeChoose: "Choose",
      alternativeHide: "Hide",
      privateJetAlternatives: "Private Jet Alternatives",
      privateJetExplore: "Explore premium alternatives",
      privateJetViewing: "You are viewing Private Jet Alternatives",
      privateJetBaggage: "Baggage",
      privateJetBaggageDimensions: "158 cm — length + width + height",
      privateJetPassengers: "Passengers",
      privateJetFlightAttendant: "Flight attendant",
      privateJetFlightDuration: "Flight duration",
      privateJetFlightsDuration: "Flights duration",
      privateJetCatering: "Catering",
      privateJetBar: "Bar",
      privateJetIncluded: "Included",
      privateJetNoImages: "No images available",
      privateJetRequest: "Request",
      privateJetSendingRequest: "Sending request",
      privateJetCancel: "Cancel",
      privateJetRequestSent: "Request sent. We'll contact you shortly to provide the final booking quote",
      instantPaymentTitle: "Confirm issuance",
      instantPaymentDesc: "After clicking the 'Issue' button, tickets will be immediately released. After the issuance, you will be able to add passport data or void the tickets.",
      instantPaymentBack: "Back",
      instantPaymentBuy: "Іssue",
      priceRange: "Price: {price_from} {price_currency} — {price_to} {price_currency}",
      priceFrom: "Price: from {price_from} {price_currency}",
      priceTo: "Price: to {price_to} {price_currency}",
      excludeCountryTransfer: "Exclude: {exclude_country_transfer}",
      flightNumbers: "Flight number: {flight_numbers}",
      transferThrough: "Transfer through: {airport_transfer}",
      connectionsCount: "{n} connection | {n} connections",
      connectionsUpTo: "Up to {n} connection | Up to {n} connections",
      connectionsFrom: "From {n} connection | From {n} connections",
      connectionsRange: "From {from} to {to} connection | From {from} to {to} connections",
      withOvernight: "With overnight",
      withoutOvernight: "Without overnight",
      privateCode: "Private code: {code}",
      checkedBaggageFilter: "Checked baggage",
      withoutCheckedBaggage: "Without checked baggage",
      cabinBaggageFilter: "Cabin baggage",
      withoutCabinBaggage: "Without cabin baggage",
      connectionUnder: "Connection < {hours} h.",
      basicTooltipTitle: "Without baggage",
      economyTooltipTitle: "With baggage",
      basicTooltipContent: "The most affordable fare, which does not include checked baggage. The price covers only hand luggage in accordance with the airline’s rules.",
      economyTooltipContent: "The most affordable fare with checked baggage and hand luggage included in accordance with the carrier’s regulations.",
      withoutBaggage: "Without baggage",
      withBaggage: "With baggage",
      bookFlightError: "Cannot book flight: selected fare is missing",
      fillDocuments: "Enter passport details for all passengers.",
      goToEditing: "Prepare offer",
      standardEditing: "Edit offer",
      goToAiEditing: "Improve with AI",
      copyText: "Copy",
      textCopied: "Text copied",
      editTextPlaceholder: "Enter your text here...",
      editableTextDescription: "Customise the offer with the selected flights and fares before sending it to the passenger",
      undoTextChanges: "Undo changes",
      maxFavoritesReached: "You can add 6 offers maximum",
      maxFaresPerFlight: "You can add 3 fares per flight maximum",
      aiEditing: "AI Assistant",
      aiPromptDescription: "Describe your request or paste your template, and AI will update the offer",
      aiPromptPlaceholder: "Make the text more structured and easier to read.",
      applyAiPrompt: "Apply",
      aiGeneratingOffer: "Adding the final touches…",
      backToStandardEditing: "Manual editing",
      goToOffer: "Go to offer",
      soldOut: "Sold out",
      offerExpiredTitle: "Time to update",
      offerExpiredDescription: "Fares may have changed. Refresh results to see the latest offers or start a new search",
      newSearch: "New Search",
      refreshResults: "Refresh Results",
      refreshingResults: "Refreshing...",
      offersHistoryTitle: "Saved offers",
      offersHistoryDescription: "Your previously selected flights and fares are saved here",
      offerUnavailableAfterRefresh: "The previously opened offer is no longer available.",
      offerHiddenByFiltersAfterRefresh: "The previously opened offer no longer matches the selected filters.",
      fareUnavailableAfterRefresh: "The previous fare is no longer available. The lowest current fare was selected.",
      refreshingResultsStatus: "Refreshing flight results.",
      resultsUpdatedStatus: "Flight results updated.",
      refreshResultsFailedStatus: "Flight results could not be refreshed.",
      filterNotRecognized: "The filter request was not recognized. Please try again.",
    },
    bookings: {
      ancillaries: "Ancillaries",
      ancillaries_price_from: "from",
      ancillaryTitleBook: "Confirm services",
      ancillaryTitleIssue: "Confirm service purchase",
      ancillaryDescriptionBook: 'According to airline rules, it is not possible to cancel services separately from the booking. Click "Book" to confirm the services.',
      ancillaryDescriptionIssue: 'According to airline rules, the issued additional services cannot be cancelled. Click "Purchase" to confirm the issue.',
      ancillaryCloseBook: "back",
      ancillaryCloseIssue: "BACK",
      ancillaryApproveBook: "Book",
      ancillaryApproveIssue: "PURCHASE",
      baggage: "Baggage",
      downloadAncillaries: "download ancillaries",
      other: "Services",
      seat: "Seat",
      seats: "Seats",
      total: "Total",
      title: "Bookings",
      till: "till",
      card: "Credit Card",
      cardNumber: "Number",
      cardOwner: "Card holder",
      cardExpiry: "Expiry",
      cardCvv: "CVС",
      tourCode: "Tour code",
      tourCodeValue: "Number",
      search: "Find",
      searchPlaceholder: "Enter locator or last name",
      booked: "Booked",
      in_progress: "In progress",
      issued: "Issued",
      noBooking: "No booking found",
      noBookingDesc: "Check if locator or last name is correct and try again.",
      noBookingForIssue: "No reservations to issue",
      noBookingForIssueDesc: "Go to «Search» section. Choose and book a flight. Then you can issue a booking.",
      noInProgressBooking: "No bookings in progress",
      noInProgressBookingDesc: "Bookings with ongoing processing will appear here. Once completed, the ticket will be displayed in the Sales section with the relevant status.",
      noIssuedBooking: "No bookings issued",
      noIssuedBookingDesc: "Open the booking and issue it. After that, you can download the ticket and send it to the passenger. You can cancel the ticket by the end of the day.",
      chooseCountry: "Select country",
      genderM: "M",
      genderF: "F",
      issueBefore: "Issue before",
      voidBefore: "Void before",
      priceValidTill_1: "The price is guaranteed until",
      priceValidTill_2: "After this, the price may change. The segments will remain active until",
      continuousPricing: "The price may change at any time. It will be verified before issuance.",
      cancelBooking: "Cancel booking",
      linkedBooking: "Linked booking:",
      issue: "Issue",
      issue_with_reprice: "Reprice+Issue",
      create_payment_link: "🔗 Create payment link",
      payment_link_created: "Link was created",
      copy_payment_link: "🔗 Copy link",
      voidAndCancel: "Void and cancel",
      downloadAllTickets: "Download all tickets",
      changes: "Changes",
      refund: "Refund",
      refundButton: "Refund",
      reissue: "Change",
      document: "Passport details",
      download: "DOWNLOAD",
      documentRequired: "Passenger's passport details must be entered before issuing the ticket",
      documentNotRequired: "Enter passenger's passport details",
      save: "Save",
      contacts: "Contact information",
      contactsRequired: "Passenger's contact information must be entered before issuing the ticket.",
      contactsNotRequired: "Enter passenger's contact information",
      frequentFlyer: "Frequent flyer number",
      frequentFlyerNotRequired: "Enter passenger's frequent flyer number",
      frequentFlyerInput: "Optional. Add your frequent flyer number to earn miles and other program benefits.",
      frequentFlyerCarrier: "Frequent flyer carrier",
      noVoidTitle: "Confirm issuance",
      noVoidClose: "Back",
      noVoidApprove: "Issue",
      repriceTitle: "The price changed",
      repriceClose: "Cancel",
      repriceApprove: "Issue",
      reshopTitle: "Price Update",
      reshopClose: "Cancel booking",
      reshopApprove: "Confirm",
      reshoppriceChanged: "The price has changed from",
      reshopDescription: "To proceed with issuance at the new price, click \"Confirm\", or \"Cancel booking\" to cancel the reservation",
      cantOpenbooking: "Can't open the booking",
      cantOpenbookingDesc: "It happens if the airline provided information that we couldn't identify. Please, contact support.",
      openBooking: "Open the booking",
      openBookingDesc: "After the opening, you will be able to issue or cancel the booking.",
      priceChanged: "Recalculated at the current rate - the price changed from",
      priceChangedOn: "to",
      adt: "Adult",
      chd: "Child",
      inf: "Infant",
      sea: "Seaman",
      yth: "Teenager",
      lastName: "Last name",
      firstName: "First name",
      dateOfBirth: "Date of birth",
      countryOfIssue: "Country of issue",
      documentNumber: "Document number",
      citizenship: "Citizenship",
      gender: "Gender",
      expirationDate: "Expiration date",
      dateOfIssue: "Date of issue",
      email: "Email",
      phone: "Phone number",
      carrier: "Carrier",
      selectBaggage: "select baggage",
      selectOther: "Select service",
      book: "Book",
      buy: "Buy",
      process: "Process",
      passenger: "Passenger",
      add: "Add",
      fake_booked: "Press «Issue» to confirm your intentions",
      updateStatus: "Update status",
      confirmChanges: "Confirm",
      confirmNewSegments: "One or more segments were not confirmed.\nThe alternative variant is offered. Press \"Confirm\" to approve the new segments\nor \"Cancel\" to cancel the booking.",
      oldSegments: "Old segments:",
      newSegments: "New segments:",
      newPrice: "The price changed from",
      newPrice1: "to",
      newPrice2: "Press \"Confirm\" to approve the new price or \"Cancel\" to cancel the booking.",
      orderCancelled: "The booking was not confirmed. Press \"Cancel\" to cancel the booking\nand make a new search.",
      cancelledTitle: "Booking was not confirmed",
      newPriceTitle: "The price changed",
      contactsInput: {
        default: "Contacts are optional. Fill in the fields in case you need to transfer customer's data to the airline.",
        KYT: "Contacts are optional. Provided email will be used for airline “Manage My Booking” login and notifications. If not provided, DRCT account info will be used.",
      },
      addAncillarySelect: "Choose more",
      refundBooking: "Refund was successfully completed and added to the \"Sales\" section",
      booking_completed: "The booking is confirmed",
      cancelReservationTimer: "Canceling your booking",
      voidReservationTimer: "Voiding your booking",
      cancelReservationTimerBtn: "Back",
      shipsFlag: "Ship's flag",
      shipsFlagSpan: "Enter the ship's flag in the format VENUS",
      shipsFlagInfoTooltip: "Enter the data as shown in the example. The information will be entered in OSI and SR formats.",
      commentTitle: "Comment",
      commentDescription: "Enter a comment before issuance. It will be visible to your colleagues and reflected in the report.",
      baggageNotification: "According to airline rules, it is not possible to cancel services separately from the booking. Click \"Book\" to confirm the services.",
      cabinBaggage: "Cabin Bags",
      checkinBaggage: "Check-in Bags",
      from: "From",
      pieces: "pcs",
      ancillaries_dimensions_cm: "cm",
      ancillaries_dimensions_linear_hint: "(height+width+length)",
      noTicketFoundForPassenger: "Error while downloading ticket",
      rebookButton: "Rebooking",
      rebookButtonTooltip: "Click to create a new booking with the same details in one click.",
      rebookIntroOk: "OK"
    },
    notifications: {
      searchInput: 'Enter locator and press enter key',
      clipboard: {
        schedulechange: {
          header: 'Topic: ❗️{locator}. Departure time change.',
          greeting: 'Hello!',
          description: 'There is a departure time change in the booking {locator} for passenger(s): {passengers}.',
          prevDataTitle: 'The previous departure time:',
          newDataTitle: 'New departure time:',
          message: 'Please inform passengers and notify us about the decision in the chat on'
        },
        cancellation: {
          header: 'Topic: ❗️{locator}. Flight cancelation',
          greeting: 'Hello!',
          description: 'There is a flight cancelation in the booking {locator} for passenger(s): {passengers}.',
          prevDataTitle: 'Canceled flight(s):',
          newDataTitle: 'The airline offered an alternative:',
          message: 'Please inform the passengers and notify about the decision in the chat on'
        },
        seatchange: {
          header: '❗️{locator}. Flight cancelation',
          greeting: 'Hello!',
          description: 'In booking {locator}, the seat assignment for passenger {passenger} has been changed in the aircraft cabin.',
          prevDataTitle: 'Previously reserved seats:',
          message: 'Please inform the passengers about the changes and, if necessary, write in the chat on the website'
        }
      }
    },
    disconnected: {
      bannerTitle: "Almost ready",
      bannerDescription: "Ask a partner to connect you to start selling tickets at airline website prices."
    },
    errors: {
      not_found: {
        title: "Page not found",
        description: "Oops, we couldn’t find this page. The link may be outdated, or there might be a typo in the address. Try returning to the homepage and continue from there.<br><br>If you need help — we’re here. Write to <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a> or use the support chat."
      },
      server_error: {
        title: "Something went wrong",
        description: "We’re experiencing a technical issue. Our team is already working on fixing it.<br><br>Please try refreshing the page now or come back a bit later. If your request is urgent, contact us at <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a>"
      },
      backToHome: "Back to home"
    },
    payment: {
      maltaTitle: "Did you know?",
      maltaAdditional: "If a problem occurs, please contact us in the chat — we will be glad to assist.",
      maltaFact1: "In 2015, Air Malta launched Sky Spa — the first ever free spa on board a commercial short-haul flight.",
      maltaFact2: "Air Malta's philosophy is based on a deep knowledge of Malta — airline staff will always tell you about Malta and answer all your questions about the Islands.",
      maltaFact3: "In 2018, Air Malta won in the TripAdvisor Travelers' Choice awards for airlines.",
      byCardTitle: "Card payment",
      byCardDescription: "Forwarding to the payment page. Enter card data and pay for the ticket. The ticket will be issued automatically."
    },
    admin: {
      today: "Today",
      week: "Week",
      month: "Month",
      partner: "Partner",
      channel: "Channel",
      tickets: "Tickets",
      emd: "EMD",
      segments: "Segments",
      earned: "Earned"
    },
    credit_card: {
      description: "Add a card or delete an existing one to update information",
      deleteCard: "Delete the card",
      number: "Card number",
      holder: "Card holder",
      expire: "Expire at",
      cvv: "CVV",
      back: "Back",
      save: "Save"
    },
    refund: {
      title: "Refund",
      description: 'The refundable amount is calculated for all passengers in the booking. Click on the "Proceed refund" button to complete the refund.',
      confirmButton: "Proceed refund",
      returnButton: "Return",
      penalty: "Penalty",
      total: "Total to refund",
      fareAndTaxes: "Fare and taxes"
    },
    reissue: {
      title: "Choose flights",
      ancillaryTitle: "Confirm reissue",
      description:"Select the flights you want to change. The changes will be applied to all passengers in the booking.",
      ancillaryDescription: "Additional services have been purchased for some flights, which will not be automatically applied to new flights. Please contact support to reattach them.",
      voidDescription: "Please note that it’s not possible to void a reissued ticket.",
      outbound: "Outbound",
      inbound: "Inbound",
      returnButton: "Return",
      changeButton: "Change",
      returnToBooking: "Return to booking",
      extraPay: "Total to be paid",
      fare: "Fare",
      taxes: "Taxes",
      penalty: "Penalty",
      total: "Total to be paid",
      surcharge: "Surcharge",
      choose: "Choose",
      confirmTitle: "Check flights and confirm changes",
      confirmDescription: "Check the flights to be exchanged and confirm the changes. Once confirmed, the flights will be changed for all passengers in the booking.",
      originalRoute: "Original",
      newRoute: "New",
      confirmButton: "Confirm changes"
    },
    rebook: {
      title: "Rebook",
      description:
        "Need more time to complete the booking? Create a new booking for the same itinerary — all passenger details will be copied automatically. Once the new booking is successfully created, the previous one will be cancelled. This option can be used only once.",
      back: "Back",
      withChanges: "Data with changes",
      withoutChanges: "Data without changes",
      continueRebooking: "Continue",
      inProgress: "Checking availability 👀",
      inProgressDescription: "Looking up flight availability and current prices.",
      resultTitle: "Flight found",
      resultDescription:
        "Check the updated price and continue the booking.",
      prevPrice: "Previous price",
      newPrice: "New price",
      book: "Book",
      doneTitle: "Almost done",
      doneDescription: "Finalizing the booking. If successful, the previous booking will be cancelled."
    },
    ai: {
      server_error: "Server error, please try again"
    },
    booking: {
      virtualInterlineAlert: "This itinerary includes two separate bookings. Please check the details before continuing"
    }
  },
  ua: {
    searchFeatures: {
      label: "Можливості пошуку",
      play: "Відтворити відео",
      pause: "Пауза",
      expand: "Розгорнути відео",
      close: "Закрити відео",
      videoError: "Не вдалося завантажити відео. Спробуйте ще раз.",
      speed: {
        title: "Видача результатів за секунди",
        description: "Перші результати — одразу. Починайте переглядати варіанти, не чекаючи завершення всього пошуку."
      },
      filters: {
        title: "Оновлені фільтри",
        description: "Фільтруйте за авіакомпаніями, часом і аеропортами, щоб знайти потрібний варіант без зайвих кроків."
      },
      controls: {
        title: "Швидкий вибір",
        description: "Обирайте аеропорти стрілками на клавіатурі та змінюйте дати одним кліком, щоб прискорити роботу."
      },
      query: {
        title: "Оновлений Copilot",
        description: "Copilot тепер краще розпізнає текст, GDS-команди та дані з бронювання."
      },
      history: {
        title: "Історія запитів під рукою",
        description: "Повертайтеся до запитів клавішами ↑ і ↓ у Copilot та AI-фільтрах без повторного введення."
      }
    },
    title: "Партнери",
    connectedPartners: "Підключені",
    allPartners: "Доступні",
    issuesTitle: "Технічні роботи",
    issuesDescription: "Зараз, ми оновлюємо DRCT та переконуємось, що все готове для роботи. Зазвичай, це займає 15 хвилин.",
    partner: "Партнер",
    chanells: "Канали",
    currency: "Валюта",
    balance: "Баланс",
    additional: "Додаткова інформація",
    noChannels: "Немає активних каналів",
    connect: "Підключити",
    pending: "В процесі...",
    tabs: {
      connectedTitle: "Ви не підключені до партнера",
      connectedDescription: "Оберіть партнера та підключіться до нього. Коли партнер підтвердить вашу заявку, ви зможете бронювати та виписувати квитки."
    },
    tickets: {
      locatorCopied: "Локатор скопійовано",
      locator: "Локатор",
      search: "Знайти",
      searchPlaceholder: "Введіть локатор, номер квитка або прізвище та натисніть enter",
      emptySearchTitle: "Квиток не знайдено",
      emptySearchDescription: "Перевірте коректність номеру бронювання, номеру квитка чи прізвища пасажира та спробуйте знову.",
      title: "Продажі",
      today: "Сьогодні",
      week: "Тиждень",
      month: "Місяць",
      export: "Експортувати в",
      date: "Дата та час",
      pax: "Пасажир",
      type: "Тип",
      number: "Номер",
      status: "Статус",
      route: "Маршрут",
      agency: "Партнер",
      company: "Компанія",
      sum: "Тотал",
      download: 'Завантажити квиток',
      downloadButton: "Завантажити",
      downloadWithPrice: "З ціною",
      downloadWithoutPrice: "Без ціни",
      downloadTitle: 'Завантажити квиток',
      downloadDescription: 'Завантажуйте квиток з тарифом, таксами і зборами або тільки з тоталом',
      downloadWithBreakdown: 'З тарифом і Таксами',
      downloadWithoutBreakdown: 'Тільки з тоталом',
      fare: 'Тариф',
      tax: 'Такси і збори',
      total: 'Тотал',
      update: "UPD",
      add: "Додати",
      ok_button: "Застосувати",
      months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      shortMonths: ['січ', 'лют', 'бер', 'квіт', 'трав', 'черв', 'лип', 'серп', 'вер', 'жовт', 'лис', 'груд'],
      shortDays: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      emptyTitle: "Не вдалось знайти квитки на вказані дати",
      emptyDescription: "Спробуйте обрати інші дати.",
      passengerCopied: "Пасажира скопійовано",
      ticketNumberCopied: "Номер скопійовано",
      emailCopied: "Електронна пошта скопійована",
    },
    transactions: {
       partner: "Компанія",
       title: "Транзакції",
       date: "Дата та час",
       initiator: "Ініціатор",
       company: "Компанія",
       description: "Опис",
       sum: "Тотал",
       emptyTitle: "У вас поки немає транзакцій",
       emptyDescription: "Після першої виписки будуть відображені наступні транзакції: списання та поповнення, виписка та повернення квитків.",
       search: "Знайти",
       searchPlaceholder: "Введіть локатор та натисніть enter",
    },
    header: {
      search: "Пошук",
      bookings: "Бронювання",
      partners: "Партнери",
      management: "Менеджмент",
      sales: "Продажі",
      analytics: "Аналітика",
      transactions: "Транзакції",
      profile: "Профіль",
      openMenu: "Відкрити меню",
      closeMenu: "Закрити меню",
      credentials: "Доступи"
    },
    profile: {
      disconnect: "Відключитись",
      profile: "Профіль",
      account: "Акаунт",
      partner: "Партнер",
      support: "Підтримка",
      firstName: "Імʼя",
      secondName: "Прізвище",
      company: "Компанія",
      logOut: "Вийти з DRCT",
      saveMain: "Зберегти",
      phoneNumber: "Номер телефону",
      mail: "Електронна пошта",
      changePhone: "Змінити",
      changeEmail: "Змінити",
      labelPhone: "Ввести номер телефону",
      hintPhone: "Введіть номер телефону. Відправимо SMS із підтвердженням",
      backPhone: "Назад",
      savePhone: "Далі",
      labelOTP: "Введіть код з SMS",
      resultOTP: "Ми відправили SMS із кодом на вказаний номер",
      resendOTP: "Надіслати код ще раз",
      changeNumberOTP: "Змінити номер",
      saveOTP: "Далі",
      labelNewEmail: "Введіть нову пошту",
      backEmail: "Назад",
      saveEmail: "Далі",
      confirmEmail: "Підтвердіть електронну пошту",
      descEmail: "Перейдіть за посиланням, надісланим на",
      spamEmail: "Якщо листа немає у вхідних повідомленнях, перевірте папку «Спам».",
      alreadyTakenEmail: "Електронна пошта вже зайнята",
      takenEmail: "Ця електронна пошта вже використовується іншим обліковим записом. Якщо ви все ще хочете змінити свою електронну пошту, будь ласка, спробуйте іншу замість",
      backToEmail: "Змінити пошту"
    },
    search: {
      flightCheckboxTooltip: 'Показати результати лише з цим напрямом',
      priceForOne: "Для 1 дорослого",
      choose: "Обрати",
      directFlight: "Прямий рейс",
      charterFlight: "Чартер",
      airlineOffer: "Пропозиція від авіакомпанії",
      airlineOfferTooltip: "Ви бачите ціни, як на сайті авіакомпанії без додаткових зборів. Натисніть «Перевірити ціну та забронювати», щоб придбати квиток на сайті авіакомпанії.\n\nЗа підтримки компанії",
      charterTooltip: "Вам щастить 😊\n\nЗнайти квитки на чартерні рейси — рідкість. Вони дешевші, ніж регулярні та пропонують прямі рейси за унікальними напрямками. Радимо звернути увагу на правила тарифу. Зазвичай, обміни та повернення не дозволені.",
      airlineOfferButton: "Перевірити ціну та забронювати",
      oneConnection: "1 стикування",
      oneStop: "1 зупинка",
      connections: "стикування",
      operated: "Виконується",
      priceWithoutBag: "Вартість без багажу",
      priceWithBag: "Вартість з багажем",
      withBag: "З багажем",
      adtHint: "Від 12 років",
      chdHint: "Від 2 до 12 років",
      infHint: "До 2 років, без місця",
      seaHint: "Торговий моряк",
      adtTitle: "Дорослі",
      chdTitle: "Діти",
      infTitle: "Немовлята",
      seaTitle: "Моряки",
      passenger: "пасажир",
      passengers1_4: "пасажири",
      passengers4_more: "пасажирів",
      promoTitle: "Додати промокод",
      promoDescription: "Введіть промокод, щоб застосувати його до бронювання. Знижка буде відображена після створення бронювання.",
      promoPlaceholder: "Ввести промокод",
      promoSubmit: "Додати",
      promoCorrect: "Промокод додано",
      baggage: "Багаж",
      under_seat: "Мала сумкa",
      underSeatBagTooltipTitle: "Мала сумкa",
      underSeatBagTooltipDimensions: "40x30x15 см",
      cabinBagTooltipTitle: "Ручна поклажа",
      cabinBagTooltipDimensions: "55x40x23 см",
      pegasusFlexibleChangeTitle: "Право на гнучку зміну",
      pegasusFlexibleRefundTitle: "Право на гнучке повернення",
      pegasusFlexibleTimelineSevenDays: "(до 7 діб до вильоту)",
      pegasusFlexibleTimelineTwoHours: "(до 2 годин до вильоту)",
      cabin_bag: "Ручна п-жа",
      seat: "Місце",
      seatFree: "Включено",
      seatPaid: "Платно",
      seatPartiallyFree: "Частково включено",
      seatNotIncluded: "Не включено",
      seatStandardIncluded: "Стандартне",
      seatStandardAndPreferredIncluded: "Стандартне і преференційне",
      priority_boarding: "Пріоритетна посадка",
      included: "Включено",
      meal: "Їжа",
      changes: "Зміни",
      refund: "Повернення",
      beforeDeparture: "До вильоту",
      afterDeparture: "Після вильоту",
      perPass: "Для 1",
      from: "Звідки",
      to: "Куди",
      search: "Пошук",
      fromDate: "Відправлення",
      backDate: "Повернення",
      dayNamesShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      dayNames: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      monthNames: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      allFlights: "Всі рейси",
      noTransfer: "Прямі",
      oneTransfer: "До 1 пересадки",
      cheapest: "Найдешевші",
      fastest: "Найшвидші",
      fare_rules: "Правила Тарифу",
      fare_rules_in_future: "Ми працюємо над впровадженням правил. Додамо їх в Вересні 🤗",
      chooseTo: "Оберіть тариф на виліт",
      chooseBack: "Оберіть тариф на приліт",
      inputDataHint: "Введіть інформацію латинськими літерами, як зазначено в документі",
      lastName: "Прізвище",
      firstName: "Імʼя",
      dateOfBirth: "Дата народження",
      gender: "Стать",
      book: "Забронювати",
      book_and_pay: "Миттєво виписати",
      createTwoBookings: "Створити 2 бронювання",
      virtualInterlineAlert: "Для цього маршруту буде створено два окремі бронювання. Перевірте деталі перед тим як продовжити",
      virtualInterlineTooltip: "<p>1. Маршрут складається з двох бронювань. Кожне потребує окремої виписки</p><p>2. Повернення, зміни, обмін і додаткові послуги виконуються окремо відповідно до правил тарифу кожного бронювання</p><p>3. Зміни або скасування в одному бронюванні не є підставою для безкоштовної зміни чи повернення в іншому</p>",
      issue: "Продовжити",
      adt: "Дорослий",
      chd: "Дитина",
      total: "Тотал",
      inf: "Немовля",
      searchTitle: "Пошук",
      searchTitleText: "Copilot",
      switchOnForm: "Форма",
      switchOnTerminal: "Термінал",
      switchOnText: "Copilot",
      copilotSearch: "Пошук",
      copilotEdit: "Редагувати",
      copilotDropImage: "Відпустіть зображення будь-де — додамо його до пошуку",
      copilotAddClarification: "За бажанням додайте фільтри, наприклад: вечірні рейси без багажу",
      copilotPastedImagePreview: "Попередній перегляд вставленого зображення",
      copilotRemoveImage: "Видалити зображення",
      unknownError: "Невідома помилка",
      removeAiFilter: "Прибрати AI-фільтр",
      exclude: "Виключити: {values}",
      directFlights: "Прямі рейси",
      upToOneConnection: "До 1 пересадки",
      removeDirectFlightsFilter: "Прибрати фільтр прямих рейсів",
      removeOneConnectionFilter: "Прибрати фільтр «До 1 пересадки»",
      resetAllFilters: "Скинути всі",
      resetFilter: "Скинути",
      filterAirlines: "Авіакомпанії",
      filterAirports: "Аеропорти",
      filterRouteAirports: "Звідки — Куди",
      filterTransferAirports: "Пересадки",
      filterTimes: "Час",
      filterTakeOff: "Виліт",
      filterLanding: "Приліт",
      filterTakeOffFrom: "Виліт з {city}",
      filterLandingAt: "Приліт до {city}",
      filterDuration: "Тривалість",
      filterTransfer: "Пересадка",
      searchMC: "Складний маршрут",
      addRoute: "Додати маршрут",
      removeRoute: 'Видалити маршрут',
      backToForm: 'Повернутися до форми',
      terminalHint: "Використовуйте звичні команди, щоб знайти рейс. Наприклад: AN15OCTKBPBCN*17OCT/1ADT/1CHD",
      formHint: "Шукайте, бронюйте та оформлюйте квитки в будь-яку точку світу.",
      textHint: "Шукайте у зручному форматі: текстом, командою або зображенням.",
      flightTo: "Переліт до",
      there: "Виліт",
      back: "Приліт",
      connection: "Стикування",
      technical_stop: "Технічна зупинка",
      duration: "тривалість",
      datepickerHeader: "Оберіть дату",
      onewayButton: "Зворотній рейс не потрібен",
      journeyTime: "В одну сторону",
      copyHint: "Натисніть, щоб скопіювати варіант",
      copyAirline: "Авіакомпанія",
      copied: "Варіант скопійовано",
      textPlaceholder: "Вставте або напишіть пошуковий запит",
      recognizeQuestion: "Коректно розпізнали?",
      submitSearchResult: "Дякуємо за ваш відгук",
      noFlightsTitle: "Змініть фільтри",
      noFlightsDescription: "Ми знайшли варіанти, але вони не підпадають під вказані фільтри. Спробуйте змінити запит, будь ласка.",
      aiFilters: "AI Фільтри",
      filterFlights: "ФІЛЬТРУВАТИ",
      filterPlaceHolder1: "Ранкові вильоти на Люфтах або Лоті",
      filterPlaceHolder2: "Тільки бізнес до 60000",
      filterPlaceHolder3: "Тільки не через Британію",
      filterPlaceHolder4: "Економ з пересадкою в Мадриді",
      filterPlaceHolder5: "Тільки вечірній приліт в Париж без багажу",
      smartSort: "Оптимальні",
      aiInfoTooltip: "Пишіть текст у будь-якому форматі, щоб відфільтрувати потрібні рейси. Вкажіть побажання по номеру рейсу, ціні або кабіні обслуговування, та натисніть «Фільтрувати». <br><br>Клікніть на «i», щоб перейти до інструкції.",
      alternativeClosedTextBold: "Ми знайшли альтернативні варіанти",
      alternativeClosedText: "Перевірте варіанти перельотів з сусідніх аеропортів",
      alternativeOpenText: "Ви переглядаєте варіанти перельотів з сусідніх аеропортів",
      alternativeFrom: "від",
      alternativeChoose: "Обрати",
      alternativeHide: "Сховати",
      privateJetAlternatives: "Варіанти перельоту приватним літаком",
      privateJetExplore: "Перегляньте преміум-альтернативи",
      privateJetViewing: "Ви переглядаєте доступні приватні літаки",
      privateJetBaggage: "Багаж",
      privateJetBaggageDimensions: "158 см — довжина + ширина + висота",
      privateJetPassengers: "Пасажирів",
      privateJetFlightAttendant: "Бортпровідник",
      privateJetFlightDuration: "Тривалість польоту",
      privateJetFlightsDuration: "Тривалість польотів",
      privateJetCatering: "Харчування",
      privateJetBar: "Бар",
      privateJetIncluded: "Включено",
      privateJetNoImages: "Зображення відсутні",
      privateJetRequest: "Надіслати запит",
      privateJetSendingRequest: "Відправляємо запит",
      privateJetCancel: "Скасувати",
      privateJetRequestSent: "Запит відправлено. Незабаром із вами звʼяжуться для фінального прорахунку бронювання",
      instantPaymentTitle: "Підтвердіть виписку",
      instantPaymentDesc: "Після натискання на кнопку «Виписати», квитки будуть одразу випущені. Після виписки зможете внести паспортні дані або войдувати квитки.",
      instantPaymentBack: "Назад",
      instantPaymentBuy: "Виписати",
      priceRange: "Ціна: {price_from} {price_currency} — {price_to} {price_currency}",
      priceFrom: "Ціна: від {price_from} {price_currency}",
      priceTo: "Ціна: до {price_to} {price_currency}",
      excludeCountryTransfer: "Виключити: {exclude_country_transfer}",
      flightNumbers: "Номер рейсу: {flight_numbers}",
      transferThrough: "Пересадка в: {airport_transfer}",
      connectionsCount: "{n} пересадка | {n} пересадки | {n} пересадок",
      connectionsUpTo: "До {n} пересадки | До {n} пересадок | До {n} пересадок",
      connectionsFrom: "Від {n} пересадки | Від {n} пересадок | Від {n} пересадок",
      connectionsRange: "Від {from} до {to} пересадки | Від {from} до {to} пересадок | Від {from} до {to} пересадок",
      withOvernight: "З ночівлею",
      withoutOvernight: "Без ночівлі",
      privateCode: "Приватний код: {code}",
      checkedBaggageFilter: "Зареєстрований багаж",
      withoutCheckedBaggage: "Без зареєстрованого багажу",
      cabinBaggageFilter: "Ручна поклажа",
      withoutCabinBaggage: "Без ручної поклажі",
      connectionUnder: "Пересадка < {hours} год",
      basicTooltipTitle: "Без багажу",
      economyTooltipTitle: "З багажем",
      basicTooltipContent: "Найдоступніший тариф, який не включає багаж. У вартість входить лише ручна поклажа згідно з правилами авіакомпанії.",
      economyTooltipContent: "Найдоступніший тариф з включеним багажем та ручною поклажею згідно з нормами перевізника.",
      withoutBaggage: "Без багажу",
      withBaggage: "З багажем",
      bookFlightError: "Неможливо забронювати політ: тариф не вибраний",
      fillDocuments: "Внесіть паспортні дані для усіх пасажирів",
      goToEditing: "Підготувати пропозицію",
      standardEditing: "Підготовка пропозиції",
      goToAiEditing: "Покращити з AI",
      copyText: "Скопіювати",
      textCopied: "Текст скопійовано",
      editTextPlaceholder: "Введіть ваш текст тут...",
      editableTextDescription: "Персоналізуйте пропозицію із вибраними рейсами і тарифами перед відправкою пасажиру",
      undoTextChanges: "Скасувати зміни",
      maxFavoritesReached: "Можна додати максимум 6 пропозицій",
      maxFaresPerFlight: "Можна додати максимум 3 тарифи на рейс",
      aiEditing: "AI-помічник",
      aiPromptDescription: "Опишіть свій запит або вставте шаблон повідомлення — AI оновить пропозицію",
      aiPromptPlaceholder: "Зроби текст більш структурованим і легшим для читання",
      applyAiPrompt: "Застосувати",
      aiGeneratingOffer: "Додаємо фінальні штрихи…",
      backToStandardEditing: "Ручне редагування",
      goToOffer: "Перейти до пропозиції",
      soldOut: "Розпродано",
      offerExpiredTitle: "Оновіть результати",
      offerExpiredDescription: "Ціни на квитки могли змінитися. Оновіть результати, щоб переглянути актуальні пропозиції, або розпочніть новий пошук",
      newSearch: "Новий пошук",
      refreshResults: "Оновити результати",
      refreshingResults: "Оновлення...",
      offersHistoryTitle: "Збережені пропозиції",
      offersHistoryDescription: "Тут зберігаються раніше обрані варіанти рейсів і тарифів",
      offerUnavailableAfterRefresh: "Раніше відкрита пропозиція більше недоступна.",
      offerHiddenByFiltersAfterRefresh: "Раніше відкрита пропозиція більше не відповідає обраним фільтрам.",
      fareUnavailableAfterRefresh: "Попередній тариф більше недоступний. Обрано найдешевший актуальний тариф.",
      refreshingResultsStatus: "Оновлюємо результати пошуку.",
      resultsUpdatedStatus: "Результати пошуку оновлено.",
      refreshResultsFailedStatus: "Не вдалося оновити результати пошуку.",
      filterNotRecognized: "Не вдалося розпізнати фільтр. Спробуйте ще раз.",
    },
    bookings: {
      ancillaries: "Додаткові послуги",
      ancillaries_price_from: "від",
      ancillaryTitleBook: "Підтвердити додаткові послуги",
      ancillaryTitleIssue: "Підтвердити покупку послуги",
      ancillaryDescriptionBook: 'Згідно з правилами авіакомпанії, неможливо скасувати послуги окремо від бронювання. Натисніть «Забронювати», щоб підтвердити послуги.',
      ancillaryDescriptionIssue: 'Згідно з правилами авіакомпанії, виписані додаткові послуги не можна буде скасувати. Натисніть «Придбати», щоб підтвердити виписку.',
      ancillaryCloseBook: "назад",
      ancillaryCloseIssue: "НАЗАД",
      ancillaryApproveBook: "Забронювати",
      ancillaryApproveIssue: "Виписати",
      baggage: "Багаж",
      downloadAncillaries: "завантажити додаткові послуги",
      other: "Послуги",
      seat: "Місце",
      seats: "Місця",
      total: "Тотал",
      title: "Бронювання",
      till: "До",
      card: "Кредитна карта",
      cardNumber: "Номер",
      cardOwner: "Імʼя власника картки",
      cardExpiry: "Дійсна до",
      cardCvv: "CVС",
      tourCode: "Туристичний код",
      tourCodeValue: "Номер",
      search: "Знайти",
      searchPlaceholder: "Введіть номер бронювання або прізвище",
      booked: "Заброньовані",
      in_progress: "В процесі",
      issued: "Виписані",
      noBooking: "Бронювання не знайдено",
      noBookingDesc: "Перевірте правильність номеру бронювання чи прізвища та спробуйте знову.",
      noBookingForIssue: "У вас поки немає бронювань",
      noBookingForIssueDesc: "Перейдіть до розділу «Пошук». Оберіть та забронюйте потрібний рейс. Після цього зможете виписати бронювання.",
      noInProgressBooking: "Немає бронювань у процесі",
      noInProgressBookingDesc: "Бронювання з незавершеною обробкою відображатимуться тут. Після завершення квиток відобразиться в розділі «Продажі» з відповідним статусом.",
      noIssuedBooking: "Немає виписаних бронювань",
      noIssuedBookingDesc: "Відкрийте бронювання та випишіть його. Після цього, зможете завантажити квиток та відправити його пасажиру. Войдувати квиток можливо до кінця дня.",
      chooseCountry: "Оберіть країну",
      genderM: "Ч",
      genderF: "Ж",
      issueBefore: "Виписати до",
      voidBefore: "Войдувати до",
      priceValidTill_1: "Ціна гарантована до",
      priceValidTill_2: "Після цього вартість може змінитись. Сегменти лишаться активними до",
      continuousPricing: "Вартість може змінитися в будь-який момент. Перевірка ціни буде виконана перед випискою.",
      cancelBooking: "Анулювати",
      linkedBooking: "Пов'язане бронювання:",
      issue: "Виписати",
      issue_with_reprice: "Перерахувати+Виписати",
      create_payment_link: "🔗 Лінк на оплату",
      payment_link_created: "Посилання створено",
      copy_payment_link: "🔗 Скопіювати лінк",
      voidAndCancel: "Войдувати та анулювати",
      downloadAllTickets: "Завантажити",
      changes: "Зміни",
      refund: "Повернення",
      refundButton: "Повернути",
      reissue: "Змінити",
      document: "Паспортні дані",
      download: "ЗАВАНТАЖИТИ",
      documentRequired: "Паспортні дані мають бути внесені до виписки бронювання",
      documentNotRequired: "Внесіть паспортні дані для всіх пасажирів",
      save: "Зберегти",
      contacts: "Контактні дані",
      contactsRequired: "Контактні дані пасажира мають бути внесені до виписки квитка.",
      contactsNotRequired: "Внесіть контактні дані пасажирів",
      frequentFlyer: "Номер мильної картки",
      frequentFlyerNotRequired: "Внесіть мильну картку пасажира",
      frequentFlyerInput: "Опціонально. Додайте номер мильної картки, щоб нараховувати милі та отримувати інші бонуси програми.",
      frequentFlyerCarrier: "Перевізник мильної картки",
      noVoidTitle: "Підтвердити виписку",
      noVoidClose: "Назад",
      noVoidApprove: "Виписати",
      repriceTitle: "Вартість змінилась",
      repriceClose: "Відмінити",
      repriceApprove: "Виписати",
      reshopTitle: "Оновлення вартості",
      reshopClose: "Анулювати бронювання",
      reshopApprove: "Підтвердити",
      reshoppriceChanged: "Ціна змінилась з",
      reshopDescription: "Щоб продовжити виписку з новою ціною, натисніть «Підтвердити», або «Анулювати бронювання» щоб скасувати бронь",
      cantOpenbooking: "Не можемо відкрити бронювання",
      cantOpenbookingDesc: "Це трапляється, якщо авіакомпанія надає інформацію, яку ми не можемо розпізнати. Зверніться, будь ласка, в чат підтримки.",
      openBooking: "Відкрийте бронювання",
      openBookingDesc: "Щойно відкриєте бронювання, зможете його виписати або анулювати.",
      priceChanged: "Вартість змінилась відповідно до курсу - вартість змінилась з",
      priceChangedOn: "на",
      adt: "Дорослий",
      chd: "Дитина",
      inf: "Немовля",
      sea: "Моряк",
      yth: "Підліток",
      lastName: "Прізвище",
      firstName: "Імʼя",
      dateOfBirth: "Дата народження",
      countryOfIssue: "Країна видачі",
      documentNumber: "Номер документу",
      citizenship: "Громадянство",
      gender: "Стать",
      expirationDate: "Дата закінчення",
      dateOfIssue: "Дата видачі",
      email: "Електронна пошта",
      phone: "Номер телефону",
      carrier: "Перевізник",
      selectBaggage: "обрати багаж",
      selectOther: "Обрати додаткові послуги",
      book: "Забронювати",
      buy: "Купити",
      process: "Оформити",
      passenger: "Пасажир",
      add: "Додати",
      fake_booked: "Натисніть «Виписати», щоб підтвердити",
      updateStatus: "Оновити статус",
      confirmChanges: "Підтвердити",
      confirmNewSegments: "Один або декілька сегментів не підверджені постачальником.\nЗапропоновано альтернативний варіант. Натисніть \"Підтвердити\",\nщоб підтвердити нові сегменти або \"Анулювати бронювання\" щоб скасувати бронь.",
      oldSegments: "Оригінальні сегменти:",
      newSegments: "Нові сегменти:",
      newPrice: "Ціна змінилась з",
      newPrice1: "на",
      newPrice2: "Для підтвердження новї вартості натисніть \"Підтвердити\"\nабо \"Анулювати бронювання\" щоб скасувати бронь.",
      orderCancelled: "Бронювання не підверджено постачальником.\nНатисніть \"Анулювати бронювання\" та зробіть новий пошук.",
      cancelledTitle: "Бронювання не підверджено",
      newPriceTitle: "Ціна змінилась",
      contactsInput: {
        default: "Контакти не є обов'язковими. Заповніть поля, якщо вам потрібно передати дані клієнта авіакомпанії.",
        KYT: "Контактні дані не обов’язкові. Указана пошта буде використана для входу в бронювання на сайті авіакомпанії та для отримання сповіщень. Якщо її не вказано, застосовується пошта з акаунту DRCT."
      },
      addAncillarySelect: "Обрати ще",
      refundBooking: "Повернення успішно проведено та додано до розділу «Продажі»",
      booking_completed: "Бронювання підтвердженно",
      cancelReservationTimer: "Анулюємо бронювання",
      voidReservationTimer: "Войдуємо бронювання",
      cancelReservationTimerBtn: "Скасувати",
      shipsFlag: "Прапор судна",
      shipsFlagSpan: "Внесіть прапор судна у форматі VENUS",
      shipsFlagInfoTooltip: "Введіть дані, як вказано в прикладі. Інформація буде внесена у OSI та SR форматах.",
      commentTitle: "Коментар",
      commentDescription: "Внесіть коментар до виписки. Він буде видимий вашим колегам та відображений у звіті.",
      baggageNotification: "Згідно з правилами авіакомпанії, неможливо скасувати послуги окремо від бронювання. Натисніть «Забронювати», щоб підтвердити послуги.",
      cabinBaggage: "Ручна поклажа",
      checkinBaggage: "Зареєстрований багаж",
      from: "Від",
      pieces: "шт",
      ancillaries_dimensions_cm: "см",
      ancillaries_dimensions_linear_hint: "(висота+ширина+довжина)",
      noTicketFoundForPassenger: "Помилка при завантаженні квитка",
      rebookButton: "Перебронювати",
      rebookButtonTooltip: "Натисніть, щоб створити нову бронь з тими самими даними в один клік.",
      rebookIntroOk: "OK"
    },
    notifications: {
      clipboard: {
        schedulechange: {
          header: 'Тема: ❗️{locator}. Зміна часу вильоту',
          greeting: 'Добрий день!',
          description: 'У бронюванні {locator} для пасажирів: {passengers} відбулась зміна часу вильоту рейсу(ів).',
          prevDataTitle: 'Оригінальний час вильоту:',
          newDataTitle: 'Актуальний час вильоту:',
          message: 'Просимо повідомити пасажирів про зміни та написати рішення в чат на сайті'
        },
        cancellation: {
          header: 'Тема: ❗️{locator}. Скасування рейсу',
          greeting: 'Добрий день!',
          description: 'У бронюванні {locator} для пасажирів: {passengers} відбулось скасування рейсу(ів).',
          prevDataTitle: 'Скасовані рейси:',
          newDataTitle: 'Авіакомпанія запропонувала альтернативу:',
          message: 'Просимо повідомити пасажирів про зміни та написати рішення в чат на сайті'
        },
        seatchange: {
          header: '❗️{locator}. Зміна місць в салоні',
          greeting: 'Добрий день!',
          description: 'У бронюванні {locator} для пасажира {passenger} відбулась зміна місць в салоні літака.',
          prevDataTitle: 'Попередньо заброньовані місця:',
          message: 'Просимо повідомити пасажирів про зміни та, в разі потреби, написати в чат на сайті'
        }
      }
    },
    disconnected: {
      bannerTitle: "Майже готово",
      bannerDescription: "Попросіть партнера підключити вас, щоб почати продавати квитки за цінами сайтів авіакомпаній."
    },
    errors: {
      not_found: {
        title: "Сторінку не знайдено",
        description: "Ой, ми не змогли знайти цю сторінку.  Можливо, посилання застаріло або в адресі є помилка. Спробуйте повернутися на головну сторінку та продовжити роботу звідти.<br><br>Якщо потрібна допомога — ми поруч. Напишіть нам на <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a> або скористайтеся чатом підтримки."
      },
      server_error: {
        title: "Щось пішло не так",
        description: "У нас виникла технічна проблема. Ми вже працюємо над тим, щоб усе запрацювало якнайшвидше.<br><br>Спробуйте оновити сторінку зараз або трохи пізніше. Якщо питання термінове — напишіть нам на <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a>"
      },
      backToHome: "На головну"
    },
    payment: {
      maltaTitle: "Чи знали ви?",
      maltaAdditional: "Якщо виникне проблема, зв'яжіться з нами в чаті — будемо раді допомогти.",
      maltaFact1: "В 2015, Air Malta запустив Sky Spa — перший безкоштовний спа-центр на борту комерційного короткомагістрального рейсу.",
      maltaFact2: "Філософія Air Malta базується на глибокому знанні Мальти — співробітники авіакомпанії завжди розкажуть вам про Мальту та дадуть відповідь на всі ваші запитання про острови.",
      maltaFact3: "У 2018 році Air Malta виграла нагороду TripAdvisor Travelers' Choice для авіакомпаній.",
      byCardTitle: "Оплата картою",
      byCardDescription: "Перенаправляємо вас на сторінку оплати. Введіть дані картки та сплатіть квиток. Квиток буде оформлений автоматично."
    },
    admin: {
      today: "Сьогодні",
      week: "Тиждень",
      month: "Місяць",
      partner: "Партнер",
      channel: "Канал",
      tickets: "Квитки",
      emd: "EMD",
      segments: "Сегментів",
      earned: "Заробили"
    },
    credit_card: {
      description: "Додайте картку або видаліть існуючу для оновлення інформації",
      deleteCard: "Видаліть карту",
      number: "Номер карти",
      holder: "Імʼя власника картки",
      expire: "Дійсна до",
      cvv: "CVV",
      back: "Назад",
      save: "Зберігти"
    },
    refund: {
      title: "Повернення",
      description: "Суму до повернення прораховано за всіх пасажирів в бронюванні. Натисніть на кнопку «Провести повернення», щоб зробити повернення.",
      confirmButton: "Підтвердити повернення",
      returnButton: "Назад",
      penalty: "Штраф",
      total: "Тотал до повернення",
      fareAndTaxes: "Тариф та збори"
    },
    reissue: {
      title: "Оберіть рейси",
      ancillaryTitle: "Підтвердіть обмін",
      description: "Оберіть рейси, які хочете змінити. Зміни застосуються до всіх пасажирів у бронюванні.",
      ancillaryDescription: "На деякі рейси були придбані додаткові послуги, які не будуть автоматично застосовані до нових рейсів. Зверніться до служби підтримки, щоб прикріпити їх.",
      voidDescription: "Зверніть увагу, що войдувати переписаний квиток неможливо.",
      outbound: "Туди",
      inbound: "Назад",
      returnButton: "Назад",
      changeButton: "Змінити",
      returnToBooking: "Назад до бронювання",
      extraPay: "Тотал до оплати",
      fare: "Тариф",
      taxes: "Збори",
      penalty: "Штраф",
      total: "Тотал до оплати",
      original: "Оригінальні",
      surcharge: "Доплата",
      choose: "Обрати",
      confirmTitle: "Перевірте рейси та підтвердіть зміни",
      confirmDescription: "Перевірте рейси для обміну та підтвердіть зміни. Після підтвердження, рейси будуть змінені для всіх пасажирів у бронюванні.",
      originalRoute: "Оригінальний маршрут",
      newRoute: "Новий маршрут",
      confirmButton: "Підтвердити зміни"
    },
    rebook: {
      title: "Перебронювати",
      description:
        "Потрібно більше часу на бронювання? Створіть нову бронь на той самий маршрут — усі дані пасажирів скопіюються автоматично. Після успішного перебронювання попередню бронь буде скасовано. Скористатись можна лише один раз.",
      back: "Назад",
      withChanges: "Дані зі змінами",
      withoutChanges: "Дані без змін",
      continueRebooking: "Продовжити",
      inProgress: "Перевіряємо доступність 👀",
      inProgressDescription: "Дивимось наявність рейсу та актуальні ціни.",
      resultTitle: "Рейс знайдено",
      resultDescription:
        "Перевірте оновлену ціну та продовжіть бронювання.",
      prevPrice: "Попередня ціна",
      newPrice: "Нова ціна",
      book: "Забронювати",
      doneTitle: "Майже готово",
      doneDescription: "Завершуємо бронювання. Якщо все пройде успішно, попередню бронь буде скасовано."
    },
    ai: {
      server_error: "Проблеми на сервері, спробуйте ще раз"
    },
    booking: {
      virtualInterlineAlert: "Цей маршрут складається з двох окремих бронювань. Перевірте деталі перед тим, як продовжити"
    }
  },
  pl: {
    searchFeatures: {
      label: "Funkcje wyszukiwania",
      play: "Odtwórz wideo",
      pause: "Pauza",
      expand: "Powiększ wideo",
      close: "Zamknij wideo",
      videoError: "Nie udało się wczytać wideo. Spróbuj ponownie.",
      speed: {
        title: "Wyniki w kilka sekund",
        description: "Pierwsze wyniki pojawiają się od razu. Przeglądaj dostępne opcje, nie czekając na zakończenie całego wyszukiwania."
      },
      filters: {
        title: "Ulepszone filtry",
        description: "Filtruj według linii lotniczych, czasu i lotnisk, aby znaleźć odpowiednią opcję bez zbędnych kroków."
      },
      controls: {
        title: "Szybki wybór",
        description: "Wybieraj lotniska strzałkami na klawiaturze i zmieniaj daty jednym kliknięciem, aby przyspieszyć pracę."
      },
      query: {
        title: "Ulepszony Copilot",
        description: "Copilot teraz dokładniej rozpoznaje tekst, polecenia GDS i dane rezerwacji."
      },
      history: {
        title: "Historia zapytań pod ręką",
        description: "Wracaj do zapytań klawiszami ↑ i ↓ w Copilot i filtrach AI bez ponownego wpisywania."
      }
    },
    title: "Partnerzy",
    connectedPartners: "Połączeni",
    allPartners: "Dostępny",
    issuesTitle: "Prace techniczne",
    issuesDescription: "Aktualizujemy DRCT i upewniamy się, że wszystko działa poprawnie. Zwykle zajmuje to 15 minut.",
    partner: "Partner",
    chanells: "Kanały",
    currency: "Waluta",
    balance: "Saldo",
    additional: "Informacje dodatkowe",
    noChannels: "Brak aktywnych kanałów",
    connect: "Połącz",
    pending: "Oczekuje...",
    tabs: {
      connectedTitle: "Nie nawiązano połączenia z partnerem",
      connectedDescription: "Wybierz partnera i połącz się z nim. Gdy partner potwierdzi Twoją aplikację, będziesz mógł rezerwować i wystawiać bilety za jego pośrednictwem."
    },
    tickets: {
      locatorCopied: "Skopiowano numer rezerwacji",
      locator: "Numer rezerwacji",
      search: "Znajdź",
      searchPlaceholder: "Wprowadź numer rezerwacji, numer biletu lub nazwisko i naciśnij klawisz Enter",
      adminSearchPlaceholder: "Wprowadź lokalizator, numer biletu, identyfikator partnera, identyfikator firmy, kod IATA lub nazwisko i naciśnij klawisz Enter",
      emptySearchTitle: "Nie znaleziono biletu",
      emptySearchDescription: "Sprawdź, czy lokalizator, numer biletu lub nazwisko są poprawne i spróbuj ponownie.",
      title: "Sprzedaż",
      today: "Dzisiaj",
      week: "Tydzień",
      month: "Miesiąc",
      export: "Wyeksportuj to",
      date: "Data i godzina",
      pax: "Pasażer",
      type: "Typ",
      number: "Numer",
      status: "Status",
      route: "Plan podróży",
      agency: "Partner",
      company: "Firma",
      sum: "Suma",
      download: 'Pobierz bilet',
      downloadButton: "Pobierz",
      downloadWithPrice: "Z ceną",
      downloadWithoutPrice: "Bez ceny",
      downloadTitle: "Pobierz bilet",
      downloadDescription: "Pobierz bilet z podatkami i opłatami za przejazd lub kwotę łączną",
      downloadWithBreakdown: 'Z opłatami i podatkami',
      downloadWithoutBreakdown: 'Suma całkowita',
      fare: "Taryfa",
      tax: 'Podatki i opłaty',
      total: "Razem",
      add: "Dodaj",
      update: "UPD",
      ok_button: "Zastosuj",
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      shortMonths: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
      shortDays: ['nd', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
      emptyTitle: "Nie ma biletów na wybrane daty",
      emptyDescription: "Spróbuj wybrać inne daty.",
      passengerCopied: "Passenger copied",
      ticketNumberCopied: "Number copied",
      emailCopied: "E-mail copied",
    },
    transactions: {
      partner: "Partner",
      title: "Transakcje",
      date: "Data i godzina",
      initiator: "Inicjator",
      company: "Firma",
      description: "Opis",
      sum: "Łącznie",
      emptyTitle: "Nie ma jeszcze żadnych transakcji",
      emptyDescription: "Po pierwszej operacji zostaną wyświetlone następujące transakcje: odpisy i doładowania, zakupione i anulowanie bilety.",
      search: "Znajdź",
      searchPlaceholder: "Wprowadź numer rezerwacji i naciśnij klawisz Enter",
    },
    header: {
      search: "Szukaj",
      bookings: "Rezerwacje",
      partners: "Partnerzy",
      management: "Zarządzanie",
      sales: "Sprzedaż",
      analytics: "Analityka",
      transactions: "Transakcje",
      profile: "Profil",
      openMenu: "Otwórz menu",
      closeMenu: "Zamknij menu",
      credentials: "Dane dostępowe"
    },
    profile: {
      disconnect: "Rozłącz",
      profile: "Profil",
      account: "Konto",
      partner: "Partner",
      support: "Wsparcie",
      firstName: "Imię",
      secondName: "Drugie imię",
      company: "Firma",
      logOut: "Wyloguj",
      saveMain: "Zapisz",
      phoneNumber: "Numer telefonu",
      changePhone: "Zmień",
      mail: "E-mail",
      changeEmail: "Zmień",
      labelPhone: "Wprowadź nowy numer telefonu",
      hintPhone: "Wprowadź swój numer telefonu, wyślemy Ci wiadomość SMS z potwierdzeniem",
      backPhone: "Wstecz",
      savePhone: "Dalej",
      labelOTP: "Wprowadź kod z wiadomości SMS",
      resultOTP: "Wysłaliśmy kod SMS na podany numer",
      resendOTP: "Wyślij kod ponownie",
      changeNumberOTP: "Zmień numer",
      saveOTP: "Dalej",
      labelNewEmail: "Wprowadź nowy e-mail",
      backEmail: "Powrót",
      saveEmail: "Następny",
      confirmEmail: "Potwierdź swój e-mail",
      descEmail: "Kliknij link, który wysłaliśmy na Twój adres e-mail",
      spamEmail: "Jeśli nie otrzymałeś wiadomości, sprawdź folder spamu",
      alreadyTakenEmail: "E-mail jest już zajęty",
      takenEmail: "Ten e-mail jest już zajęty przez inne konto. Jeśli nadal chcesz zmienić swój adres e-mail, wprowadź inny adres",
      backToEmail: "Zmień e-mail"
    },
    search: {
      flightCheckboxTooltip: 'Pokaż wyniki tylko w tym obszarze',
      priceForOne: "Za 1 osobę dorosłą",
      choose: "Wybierz",
      directFlight: "Lot bezpośredni",
      charterFlight: "Czarter",
      airlineOffer: "Oferta linii lotniczej",
      airlineOfferTooltip: "Ceny widzisz jak na stronie linii lotniczej, bez dodatkowych opłat. Kliknij „Sprawdź cenę i rezerwuj”, aby kupić bilet na stronie linii lotniczej.\n\nWe współpracy z",
      charterTooltip: "Masz szczęście 😊\n\nZnalezienie biletów na loty czarterowe jest rzadkością. Są one tańsze niż regularne loty i oferują bezpośrednie loty do wyjątkowych miejsc. Radzimy zwrócić uwagę na zasady taryfy. Zazwyczaj wymiany i zwroty nie są dozwolone.",
      airlineOfferButton: "Sprawdź cenę i rezerwuj",
      oneConnection: "1 przesiadka",
      oneStop: "1 przystanek",
      connections: "przesiadki",
      operated: "Obsługiwany przez",
      priceWithoutBag: "Cena bez bagażu",
      priceWithBag: "Cena z bagażem",
      withBag: "Z bagażem",
      adtHint: "Powyżej 12 lat",
      chdHint: "Od 2 do 12 lat",
      infHint: "Do 2 lat, bez miejsca",
      seaHint: "marynarz floty handlowej",
      adtTitle: "Dorośli",
      chdTitle: "Dzieci",
      infTitle: "Niemowlęta",
      seaTitle: "Marynarze",
      passenger: "pasażer",
      passengers1_4: "pasażerowie",
      passengers4_more: "pasażerowie",
      promoTitle: "Dodaj kod promocyjny",
      promoDescription: "Wprowadź kod promocyjny, aby zastosować go do rezerwacji. Zniżka zostanie naliczona po utworzeniu rezerwacji.",
      promoPlaceholder: "Wprowadź kod promocyjny",
      promoSubmit: "Dodaj",
      promoCorrect: "Kod promocyjny został dodany",
      baggage: "Bagaż",
      under_seat: "Mała torba",
      underSeatBagTooltipTitle: "Mała torba",
      underSeatBagTooltipDimensions: "40x30x15 cm",
      cabinBagTooltipTitle: "Bagaż p-ny",
      cabinBagTooltipDimensions: "55x40x23 cm",
      pegasusFlexibleChangeTitle: "Prawo do elastycznej zmiany",
      pegasusFlexibleRefundTitle: "Prawo do elastycznego zwrotu",
      pegasusFlexibleTimelineSevenDays: "(do 7 dni przed lotem)",
      pegasusFlexibleTimelineTwoHours: "(do 2 godzin przed lotem)",
      cabin_bag: "Bagaż p-ny",
      seat: "Miejsce",
      seatFree: "Wliczone",
      seatPaid: "Płatne",
      seatPartiallyFree: "Częściowo wliczone",
      seatNotIncluded: "Nie wliczone",
      seatStandardIncluded: "Standardowe",
      seatStandardAndPreferredIncluded: "Standardowe i preferowane",
      priority_boarding: "Priorytetowe wejście na pokład",
      included: "Wliczone",
      meal: "Posiłek",
      changes: "Zmiany",
      refund: "Zwrot",
      beforeDeparture: "Przed wylotem",
      afterDeparture: "Po wylocie",
      perPass: "Za 1",
      from: "Od",
      to: "Do",
      search: "Szukaj",
      fromDate: "Odlot",
      backDate: "Powrót",
      dayNamesShort: ['ni', 'po', 'wt', 'śr', 'cz', 'pi', 'so'],
      dayNames: ['ni', 'po', 'wt', 'śr', 'cz', 'pi', 'so'],
      monthNames: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
      allFlights: "Wszystkie loty",
      noTransfer: "Bezpośrednie",
      oneTransfer: "1 przesiadka",
      cheapest: "Najtańsze",
      fastest: "Najszybszy",
      fare_rules: "Warunki taryfy",
      fare_rules_in_future: "Pracujemy nad wdrożeniem warunków taryfy. Dodamy je we wrześniu рџ¤-",
      chooseTo: "Wybierz taryfę dla lotu wychodzącego",
      chooseBack: "Wybierz taryfę dla lotu powrotnego",
      inputDataHint: "Wprowadź dane bez użycia polskich znaków, zgodnie z dokumentem",
      lastName: "Nazwisko",
      firstName: "Imię",
      dateOfBirth: "Data urodzenia",
      gender: "Płeć",
      book: "Rezerwacja",
      book_and_pay: "Błyskawiczne wystaw",
      createTwoBookings: "Utwórz 2 rezerwacje",
      virtualInterlineAlert: "Dla tej podróży zostaną utworzone dwie oddzielne rezerwacje. Sprawdź szczegóły przed kontynuowaniem",
      virtualInterlineTooltip: "<p>1. Ta podróż obejmuje dwie rezerwacje. Każdą z nich należy wystawić oddzielnie</p><p>2. Zwroty, zmiany, wymiany i usługi dodatkowe są realizowane oddzielnie zgodnie z zasadami taryfy każdej rezerwacji</p><p>3. Zmiany lub odwołania w jednej rezerwacji nie uprawniają do bezpłatnej zmiany ani zwrotu w drugiej</p>",
      issue: "Kontynuacja",
      adt: "Dorosły",
      chd: "Dziecko",
      total: "Razem",
      inf: "Niemowlę",
      searchTitle: "Szukaj",
      searchTitleText: "Copilot",
      switchOnForm: "Forma",
      switchOnTerminal: "Terminal",
      switchOnText: "Copilot",
      copilotSearch: "Szukaj",
      copilotEdit: "Edytuj",
      copilotDropImage: "Upuść obraz w dowolnym miejscu, aby dodać go do wyszukiwania",
      copilotAddClarification: "Możesz dodać filtry, na przykład: loty wieczorne bez bagażu",
      copilotPastedImagePreview: "Podgląd wklejonego obrazu",
      copilotRemoveImage: "Usuń obraz",
      unknownError: "Nieznany błąd",
      removeAiFilter: "Usuń filtr AI",
      exclude: "Wyklucz: {values}",
      directFlights: "Loty bezpośrednie",
      upToOneConnection: "Maks. 1 przesiadka",
      removeDirectFlightsFilter: "Usuń filtr lotów bezpośrednich",
      removeOneConnectionFilter: "Usuń filtr: maks. 1 przesiadka",
      resetAllFilters: "Usuń",
      resetFilter: "Zresetuj",
      filterAirlines: "Linie lotnicze",
      filterAirports: "Lotniska",
      filterRouteAirports: "Skąd — Dokąd",
      filterTransferAirports: "Przesiadki",
      filterTimes: "Godziny",
      filterTakeOff: "Wylot",
      filterLanding: "Przylot",
      filterTakeOffFrom: "Wylot z {city}",
      filterLandingAt: "Przylot do {city}",
      filterDuration: "Czas trwania",
      filterTransfer: "Przesiadka",
      searchMC: "Wiele miejsc",
      addRoute: "Dodaj trasę",
      removeRoute: 'Usuń trasę',
      backToForm: 'Powrót do formularza',
      terminalHint: "Użyj standardowych wpisów, aby znaleźć lot. Na przykład: AN15OCTKBPBCN*17OCT/1ADT/1CHD",
      formHint: "Wyszukaj, zarezerwuj i wystaw bilety do dowolnego miejsca na świecie",
      textHint: "Szukaj w wygodnym formacie: tekstem, komendą lub obrazem.",
      flightTo: "Lot do",
      there: "Wyloty",
      back: "Przyloty",
      connection: "Przesiadka",
      technical_stop: "postój techniczny",
      duration: "czas trwania",
      datepickerHeader: "Wybierz datę",
      onewayButton: "Bez lotu powrotnego",
      journeyTime: "Czas podróży",
      copyHint: "Kliknij, aby skopiować opcję",
      copyAirline: "Linia lotnicza",
      copied: "Skopiowana opcja",
      textPlaceholder: "Wklej lub wpisz zapytanie wyszukiwania",
      recognizeQuestion: "Czy rozpoznaliśmy je poprawnie?",
      submitSearchResult: "Dziękujemy za odpowiedź",
      noFlightsTitle: "Zmień filtry",
      noFlightsDescription: "Znaleźliśmy opcje, ale nie pasują one do określonych filtrów. Zmodyfikuj wyszukiwanie.",
      aiFilters: "AI Filtry",
      filterFlights: "FILTRUJ",
      filterPlaceHolder1: "Poranne odloty na pokładzie Lufthansa lub Lot",
      filterPlaceHolder2: "Tylko biznes do 25000 PLN",
      filterPlaceHolder3: "Nie przez Wielką Brytanię",
      filterPlaceHolder4: "Ekonomiczny z międzylądowaniem w Madrycie",
      filterPlaceHolder5: "Tylko wieczorny przylot do Paryża bez bagażu",
      smartSort: "Optymalny",
      aiInfoTooltip: "Wpisz tekst w dowolnym formacie, aby przefiltrować wybrane loty. Określ preferencje dotyczące numeru lotu, ceny lub klasy obsługi, a następnie kliknij „Filtruj”. <br><br>Kliknij „i”, aby przejść do instrukcji.",
      alternativeClosedTextBold: "Znaleźliśmy alternatywne opcje",
      alternativeClosedText: "Sprawdź opcje lotów z sąsiednich lotnisk",
      alternativeOpenText: "Przeglądasz opcje lotów z sąsiednich lotnisk",
      alternativeFrom: "od",
      alternativeChoose: "Wybierz",
      alternativeHide: "Ukryj",
      privateJetAlternatives: "Alternatywne loty prywatne",
      privateJetExplore: "Poznaj alternatywne opcje klasy premium",
      privateJetViewing: "Przeglądasz dostępne loty prywatne",
      privateJetBaggage: "Bagaż",
      privateJetBaggageDimensions: "158 cm — długość + szerokość + wysokość",
      privateJetPassengers: "Pasażerów",
      privateJetFlightAttendant: "Personel pokładowy",
      privateJetFlightDuration: "Czas lotu",
      privateJetFlightsDuration: "Czas lotów",
      privateJetCatering: "Catering",
      privateJetBar: "Bar",
      privateJetIncluded: "W cenie",
      privateJetNoImages: "Brak dostępnych zdjęć",
      privateJetRequest: "Wyślij zapytanie",
      privateJetSendingRequest: "Wysyłanie zapytania",
      privateJetCancel: "Anuluj",
      privateJetRequestSent: "Zapytanie zostało wysłane. Wkrótce skontaktujemy się z Tobą w sprawie ostatecznej wyceny rezerwacji",
      instantPaymentTitle: "Potwierdź oświadczenie",
      instantPaymentDesc: "Po naciśnięciu przycisku „Zapisz się” bilety zostaną wydane natychmiast. Po złożeniu oświadczenia możesz wpisać dane paszportowe lub wprowadzić bilety.",
      instantPaymentBack: "Powrót",
      instantPaymentBuy: "Wystaw",
      priceRange: "Cena: {price_from} {price_currency} — {price_to} {price_currency}",
      priceFrom: "Cena: od {price_from} {price_currency}",
      priceTo: "Cena: do {price_to} {price_currency}",
      excludeCountryTransfer: "Wyklucz: {exclude_country_transfer}",
      flightNumbers: "Numer lotu: {flight_numbers}",
      transferThrough: "Przesiadka w: {airport_transfer}",
      connectionsCount: "{n} przesiadka | {n} przesiadki | {n} przesiadek",
      connectionsUpTo: "Do {n} przesiadki | Do {n} przesiadek | Do {n} przesiadek",
      connectionsFrom: "Od {n} przesiadki | Od {n} przesiadek | Od {n} przesiadek",
      connectionsRange: "Od {from} do {to} przesiadki | Od {from} do {to} przesiadek | Od {from} do {to} przesiadek",
      withOvernight: "Z noclegiem",
      withoutOvernight: "Bez noclegu",
      privateCode: "Kod prywatny: {code}",
      checkedBaggageFilter: "Bagaż rejestrowany",
      withoutCheckedBaggage: "Bez bagażu rejestrowanego",
      cabinBaggageFilter: "Bagaż podręczny",
      withoutCabinBaggage: "Bez bagażu podręcznego",
      connectionUnder: "Przesiadka < {hours} godz.",
      basicTooltipTitle: "Bez bagażu",
      economyTooltipTitle: "Z bagażem",
      basicTooltipContent: "Najtańsza taryfa, która nie obejmuje bagażu rejestrowanego. Cena obejmuje jedynie bagaż podręczny zgodnie z zasadami linii lotniczej.",
      economyTooltipContent: "Najtańsza taryfa z bagażem rejestrowanym i bagażem podręcznym, zgodnie z zasadami przewoźnika.",
      withoutBaggage: "Bez bagażu",
      withBaggage: "Z bagażem",
      bookFlightError: "Nie można zarezerwować lotu: taryfę nie wybrano",
      fillDocuments: "Wprowadź dane paszportowe dla wszystkich pasażerów.",
      goToEditing: "Przygotuj ofertę",
      standardEditing: "Przygotowanie oferty",
      goToAiEditing: "Ulepsz z pomocą AI",
      copyText: "Kopiuj",
      textCopied: "Tekst skopiowany",
      editTextPlaceholder: "Wpisz swój tekst tutaj...",
      editableTextDescription: "Spersonalizuj ofertę z wybranymi lotami i taryfami przed wysłaniem jej pasażerowi",
      undoTextChanges: "Cofnij zmiany",
      maxFavoritesReached: "Możesz dodać maksymalnie 6 ofert",
      maxFaresPerFlight: "Możesz dodać maksymalnie 3 taryfy na lot",
      aiEditing: "Asystent AI",
      aiPromptDescription: "Opisz swoje polecenie lub wklej szablon, a AI zaktualizuje ofertę",
      aiPromptPlaceholder: "Uporządkuj tekst i spraw, aby był łatwiejszy do przeczytania.",
      applyAiPrompt: "Zastosuj",
      aiGeneratingOffer: "Dodajemy ostatnie szlify…",
      backToStandardEditing: "Edycja ręczna",
      goToOffer: "Go to offer",
      soldOut: "Wyprzedane",
      offerExpiredTitle: "Odśwież wyniki",
      offerExpiredDescription: "Ceny mogły ulec zmianie. Odśwież wyniki, aby zobaczyć najnowsze oferty, lub rozpocznij nowe wyszukiwanie",
      newSearch: "Nowe wyszukiwanie",
      refreshResults: "Odśwież wyniki",
      refreshingResults: "Odświeżanie...",
      offersHistoryTitle: "Zapisane oferty",
      offersHistoryDescription: "Tutaj znajdziesz wcześniej wybrane loty i taryfy",
      offerUnavailableAfterRefresh: "Poprzednio otwarta oferta nie jest już dostępna.",
      offerHiddenByFiltersAfterRefresh: "Poprzednio otwarta oferta nie spełnia już wybranych filtrów.",
      fareUnavailableAfterRefresh: "Poprzednia taryfa nie jest już dostępna. Wybrano najtańszą aktualną taryfę.",
      refreshingResultsStatus: "Odświeżanie wyników lotów.",
      resultsUpdatedStatus: "Wyniki lotów zostały odświeżone.",
      refreshResultsFailedStatus: "Nie udało się odświeżyć wyników lotów.",
      filterNotRecognized: "Nie rozpoznano filtra. Spróbuj ponownie.",
    },
    bookings: {
      ancillaries: "Dodatki",
      ancillaries_price_from: "od",
      ancillaryTitleBook: "Potwierdź usługi",
      ancillaryTitleIssue: "Potwierdź zakup usług",
      ancillaryDescriptionBook: 'Zgodnie z zasadami linii lotniczych nie ma możliwości anulowania usług dodatkowych. Kliknij "Zarezerwuj", aby potwierdzić usługi.',
      ancillaryDescriptionIssue: 'Zgodnie z zasadami linii lotniczych nie można anulować wykupionych usług dodatkowych. Kliknij "Wykup", aby potwierdzić wystawienie.',
      ancillaryCloseBook: "Powrót",
      ancillaryCloseIssue: "WSTECZ",
      ancillaryApproveBook: "Zarezerwuj",
      ancillaryApproveIssue: "WYKUP",
      baggage: "Bagaż",
      downloadAncillaries: "pobierz dodatki",
      other: "Usługi",
      seat: "Miejsce",
      seats: "Miejsca",
      total: "Razem",
      title: "Rezerwacje",
      till: "do",
      card: "Karta kredytowa",
      cardNumber: "Numer",
      cardOwner: "Posiadacz karty",
      cardExpiry: "Wygaśnięcie",
      cardCvv: "CVC",
      tourCode: "Tour code",
      tourCodeValue: "Kod tour",
      search: "Znajdź",
      searchPlaceholder: "Wprowadź numer rezerwacji lub nazwisko",
      booked: "Rezerw",
      in_progress: "W trakcie",
      issued: "Wystawiono",
      noBooking: "Nie znaleziono rezerwacji",
      noBookingDesc: "Sprawdź, czy numer rezerwacji lub nazwisko są poprawne i spróbuj ponownie",
      noBookingForIssue: "Brak rezerwacji do wystawienia",
      noBookingForIssueDesc: 'Przejdź do sekcji "Szukaj". Wybierz i zarezerwuj lot. Następnie możesz wystawić rezerwację.',
      noInProgressBooking: "Brak rezerwacji w toku",
      noInProgressBookingDesc: 'Rezerwacje w trakcie przetwarzania będą wyświetlane tutaj. Po zakończeniu bilet pojawi się w sekcji Sprzedaż z odpowiednim statusem.',
      noIssuedBooking: "Brak wystawionych rezerwacji",
      noIssuedBookingDesc: "Otwórz rezerwację i wystaw ją. Następnie możesz pobrać bilet i wysłać go pasażerowi. Bilet można unieważnić do końca dnia.",
      chooseCountry: "Wybierz kraj",
      genderM: "M",
      genderF: "K",
      issueBefore: "Wykup przed",
      voidBefore: "Unieważnij przed",
      priceValidTill_1: "Cena jest gwarantowana do",
      priceValidTill_2: "Po tym czasie koszt może ulec zmianie. Segmenty pozostaną aktywne do",
      continuousPricing: "Cena może ulec zmianie w dowolnym momencie. Zostanie zweryfikowana przed wystawieniem.",
      cancelBooking: "Anulować",
      linkedBooking: "Powiązana rezerwacja:",
      issue: "Wystaw",
      create_payment_link: "🔗 Utwórz link do płatności",
      payment_link_created: "Link został utworzony",
      copy_payment_link: "🔗 Kopiuj link",
      voidAndCancel: "Unieważnij i anuluj",
      downloadAllTickets: "Pobierz wszystkie bilety",
      changes: "Zmiany",
      refund: "Zwrot",
      document: "Szczegóły paszportu",
      download: "POBIERZ",
      documentRequired: "Dane paszportowe pasażera muszą zostać wprowadzone przed wystawieniem biletu",
      documentNotRequired: "Wprowadź dane paszportowe pasażera",
      save: "Zapisz",
      contacts: "Informacje kontaktowe",
      contactsRequired: "Dane kontaktowe pasażera muszą zostać wprowadzone przed wystawieniem biletu.",
      contactsNotRequired: "Wprowadź dane kontaktowe pasażera",
      frequentFlyer: "Numer karty stałego klienta",
      frequentFlyerNotRequired: "Wprowadź kartę mydlaną pasażera",
      frequentFlyerInput: "Opcjonalnie. Podaj numer karty stałego klienta, aby naliczać mile i otrzymywać inne korzyści programu.",
      frequentFlyerCarrier: "Linia lotnicza karty",
      noVoidTitle: "Potwierdź wystawienie biletu",
      noVoidClose: "Back",
      noVoidApprove: "Wystaw",
      repriceTitle: "Cena uległa zmianie",
      repriceClose: "Anuluj",
      repriceApprove: "Wystaw",
      reshopTitle: "Aktualizacja ceny",
      reshopClose: "ANULUJ REZERWACJĘ",
      reshopApprove: "POTWIERDŹ",
      reshoppriceChanged: "Cena zmieniła się z",
      reshopDescription: "Aby kontynuować wystawienie biletu w nowej cenie, kliknij „Potwierdź”, lub „Anuluj rezerwację”, aby anulować rezerwację",
      cantOpenbooking: "Nie można otworzyć rezerwacji",
      cantOpenbookingDesc: "Dzieje się tak, jeśli linia lotnicza podała informacje, których nie mogliśmy zidentyfikować. Prosimy o kontakt z pomocą techniczną",
      openBooking: "Otwórz rezerwację",
      openBookingDesc: "Po otwarciu będziesz mógł wystawić lub anulować rezerwację",
      priceChanged: "Przeliczono według aktualnej stawki - cena zmieniła się z",
      priceChangedOn: "do",
      adt: "Dorosły",
      chd: "Dziecko",
      inf: "Niemowlę",
      sea: "Marynarz",
      yth: "Nastolatek",
      lastName: "Nazwisko",
      firstName: "Imię",
      dateOfBirth: "Data urodzenia",
      countryOfIssue: "Kraj wydania",
      documentNumber: "Numer dokumentu",
      citizenship: "Obywatelstwo",
      gender: "Płeć",
      expirationDate: "Data wygaśnięcia",
      dateOfIssue: "Data wydania",
      email: "Email",
      phone: "Numer telefonu",
      carrier: "Przewoźnik",
      selectBaggage: "wybierz bagaż",
      selectOther: "Wybierz usługi dodatkowe",
      book: "Zarezerwuj",
      buy: "Wykup",
      process: "Przetwórz",
      passenger: "Pasażer",
      add: "Dodaj",
      fake_booked: 'Naciśnij "Wykup", aby potwierdzić swoje zamiary',
      updateStatus: "Zaktualizuj status",
      confirmChanges: "Potwierdź",
      confirmNewSegments: 'Jeden lub więcej segmentów nie zostało potwierdzonych.\nOferowany jest wariant alternatywny. Naciśnij "Potwierdź", aby zatwierdzić nowe segmenty, lub "Anuluj", aby anulować rezerwację.',
      oldSegments: "Stare segmenty:",
      newSegments: "Nowe segmenty:",
      newPrice: "Cena zmieniła się z",
      newPrice1: "do",
      newPrice2: 'Naciśnij "Potwierdź", aby zatwierdzić nową cenę, lub "Anuluj", aby anulować rezerwację.',
      orderCancelled: 'Rezerwacja nie została potwierdzona. Naciśnij "Anuluj", aby anulować rezerwację i przeprowadzić nowe wyszukiwanie.',
      cancelledTitle: "Rezerwacja nie została potwierdzona",
      newPriceTitle: "Cena uległa zmianie",
      contactsInput: {
        default: "Kontakty są opcjonalne. Wypełnij te pola, jeśli chcesz przesłać dane klienta do linii lotniczej.",
        KYT: "Dane kontaktowe nie są obowiązkowe. Podany adres e-mail zostanie użyty do logowania się do rezerwacji na stronie linii lotniczej oraz do otrzymywania powiadomień. Jeśli nie zostanie podany, zostanie użyty adres e-mail z konta DRCT.",
      },
      addAncillarySelect: "Wybierz więcej",
      cancelReservationTimer: "Anulowanie rezerwacji",
      voidReservationTimer: "Wprowadź rezerwację",
      cancelReservationTimerBtn: "Powrót",
      shipsFlag: "Flaga statku",
      shipsFlagSpan: "Wprowadź banderę statku w formacie VENUS",
      shipsFlagInfoTooltip: "Wprowadź dane w sposób pokazany w przykładzie. Informacje zostaną wprowadzone w formatach OSI i SR.",
      commentTitle: "Komentarz",
      commentDescription: "Wprowadź komentarz przed wystawieniem. Będzie widoczny dla zespołu i zapisany w raporcie.",
      baggageNotification: "Zgodnie z przepisami linii lotniczej nie można anulować usług osobno od rezerwacji. Kliknij „Zarezerwuj”, aby potwierdzić usługi.",
      cabinBaggage: "Bagaż podręczny",
      checkinBaggage: "Bagaż rejestrowany",
      from: "Od",
      pieces: "szt.",
      ancillaries_dimensions_cm: "cm",
      ancillaries_dimensions_linear_hint: "(wysokość+szerokość+długość)",
      noTicketFoundForPassenger: "Problem podczas pobierania biletu",
      rebookButton: "Przebookować",
      rebookButtonTooltip: "Kliknij, aby utworzyć nową rezerwację z tymi samymi danymi jednym kliknięciem.",
      rebookIntroOk: "OK"
    },
    rebook: {
      title: "Ponowna rezerwacja",
      description:
        "Potrzebujesz więcej czasu na dokonanie rezerwacji? Utwórz nową rezerwację dla tej samej trasy — wszystkie dane pasażerów zostaną automatycznie skopiowane. Po pomyślnym utworzeniu nowej rezerwacji poprzednia zostanie anulowana. Z tej opcji można skorzystać tylko raz.",
      back: "Wstecz",
      withChanges: "Data with changes",
      withoutChanges: "Data without changes",
      continueRebooking: "Kontynuuj",
      inProgress: "Sprawdzamy dostępność 👀",
      inProgressDescription: "Sprawdzamy dostępność lotu i aktualne ceny.",
      resultTitle: "Znaleźliśmy lot",
      resultDescription:
        "Sprawdź zaktualizowaną cenę i kontynuuj rezerwację.",
      prevPrice: "Poprzednia cena",
      newPrice: "Nowa cena",
      book: "Zarezerwuj",
      doneTitle: "Już prawie gotowe",
      doneDescription: "Kończymy rezerwację. Jeśli wszystko się powiedzie, poprzednia rezerwacja zostanie anulowana."
    },
    disconnected: {
      bannerTitle: "Prawie gotowe",
      bannerDescription: "Poproś partnera o połączenie, aby rozpocząć sprzedaż biletów po cenach obowiązujących na stronach linii lotniczych."
    },
    errors: {
      not_found: {
        title: "Nie znaleziono strony",
        description: "Ups, nie mogliśmy znaleźć tej strony. Link mógł być nieaktualny lub w adresie jest błąd. Spróbuj wrócić na stronę główną i kontynuować stamtąd.<br><br>Jeśli potrzebujesz pomocy — jesteśmy tu. Napisz do <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a> lub skorzystaj z czatu wsparcia."
      },
      server_error: {
        title: "Coś poszło nie tak",
        description: "Wystąpił problem techniczny. Już pracujemy nad jego rozwiązaniem.<br><br>Spróbuj odświeżyć stronę teraz lub wróć za jakiś czas. Jeśli sprawa jest pilna, napisz do nas na <a href=\"mailto:care{'@'}drct.aero\">care{'@'}drct.aero</a>"
      },
      backToHome: "Powrót do strony głównej"
    },
    payment: {
      maltaTitle: "Czy wiedziałeś?",
      maltaAdditional: "Jeśli pojawi się problem prosimy o kntak z pomocą techniczną - z przyjemnością pomożemy.",
      maltaFact1: "W 2015, Air Malta uruchomiła Sky Spa - pierwsze darmowe spa na rejsach krótkodystansowych.",
      maltaFact2: "FFilozofia Air Malta opiera się na dogłębnej znajomości Malty - pracownicy linii zawsze opowiedzą o Malcie i odpowiedzą na wszystkie pytania dotyczące Wysp.",
      maltaFact3: "W 2018 roku Air Malta zwyciężyła w plebiscycie TripAdvisor Travelers' Choice dla linii lotniczych.",
      byCardTitle: "Płatność kartą",
      byCardDescription: "Przekierowanie do strony płatności. Wprowadź dane karty i zapłać za bilet. Bilet zostanie wykupiony automatycznie."
    },
    admin: {
      today: "Dziś",
      week: "Tydzień",
      month: "Miesiąc",
      partner: "Partner",
      channel: "Kanał",
      tickets: "Bilety",
      emd: "EMD",
      segments: "Segmenty",
      earned: "Zarobiono"
    },
    credit_card: {
      description: "Dodaj kartę lub usuń istniejącą, aby zaktualizować informacje",
      deleteCard: "Usuń kartę",
      number: "Numer karty",
      holder: "Posiadacz karty",
      expire: "Wygasa w",
      cvv: "CVV",
      back: "Wstecz",
      save: "Zapisz"
    },
    ai: {
      server_error: "Server error, please try again"
    },
    booking: {
      virtualInterlineAlert: "Ta podróż obejmuje dwie oddzielne rezerwacje. Sprawdź szczegóły przed kontynuowaniem"
    }
  }
}
